import React, {Component} from 'react';
import {connect} from 'react-redux';

import {updateUserOffline} from '../../../actions/rooms';

import {BobTVUser} from '../BobTVUser/index';

import Registry from '../../../registry/index';

import '../../../3rdparty/date.format';
import {ROOM_TYPE_PERSONAL} from '../../../constants/rooms';

class ChatLogItemGeneral extends Component {
    mentionEvents = {
        click: function(event) {
            event.preventDefault();

            let {openVideoWindow} = this.props;
            let user = this.getMentionUser(event.target);

            if (user) {
                openVideoWindow(user.ufrag);
            }
        },
        contextmenu: function(event) {
            event.preventDefault();
            //event.persist();
            
            let {showUserContextMenu} = this.props;
            let user = this.getMentionUser(event.target);

            if (user) {
                showUserContextMenu(event, user);
            }
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            message : this.props.message.rendered,
            parsed_message : ChatLogItemGeneral.parseEmojies(this.props.message.rendered)
        };

        this.onAuthorLeftClick = this.onAuthorLeftClick.bind(this);
        this.onAuthorRightClick = this.onAuthorRightClick.bind(this);

        this.getMentionUser = this.getMentionUser.bind(this);
        for (let event in this.mentionEvents) this.mentionEvents[event] = this.mentionEvents[event].bind(this);
    }

    getMentionUser(mentionElement) {
        let {mentionUsers} = this.props;
        return mentionUsers.filter(function(mentionUser) { return mentionUser.nick == mentionElement.textContent })[0];
    }

    onAuthorLeftClick() {
        let {user} = this.props;

        let roomEditorInstanceId = Registry.get('roomEditorInstance_id');
        let roomEditorInstance = Registry.get(roomEditorInstanceId);

        if (roomEditorInstance) {
            roomEditorInstance.insertMention(user.nick);
        }
    }

    onMute = () => {
        const {user, message, currentUser, currentRoomInfo} = this.props;
        const siteInterface = Registry.get('siteInterface');

        let room_id = currentRoomInfo.roomid;
        let kind = "all";

        if (currentRoomInfo.type === ROOM_TYPE_PERSONAL && currentRoomInfo.creator.uid === currentUser.uid) {
            kind = "room";
        }

        siteInterface.mute({
            kind,
            room_id,
            id: user.uid,
            msg: message.message,
            server_id: __login_data.server_id
        })
            .then(res => {
                if (res.data.status === "success" && !user.online) {
                    user.certified = false;
                    this.props.updateUserOffline(user, room_id)
                }
            })
    };

    onUnMute = () => {
        const {user, currentRoomInfo, currentUser} = this.props;
        const siteInterface = Registry.get('siteInterface');

        let request = {
            id: user.uid,
            kind: "all",
            server_id: __login_data.server_id,
        };

        if (currentRoomInfo.type === ROOM_TYPE_PERSONAL && currentRoomInfo.creator.uid === currentUser.uid) {
            request.kind = "room";
            request.room_id = currentRoomInfo.id;
        }

        siteInterface.unmute(request)
            .then(res => {
                if (res.data.status === "success" && !user.online) {
                    user.certified = true;
                    this.props.updateUserOffline(user, room_id)
                }
            })
    };

    onAuthorRightClick(event, user) {
        event.preventDefault();
        event.persist();
        this.props.showUserContextMenu(event, user);
    }

    onMentionMouseMove(event) {
        //console.log('onMentionMouseMove');
    }

    componentDidMount() {
        if(this.itemElement) {
            let mentions = this.itemElement.querySelectorAll('.mention');

            let callback = function (mention) {
                for (let event in this.mentionEvents) {
                    mention.addEventListener(event, this.mentionEvents[event])
                }
            };

            if (typeof mentions.forEach == 'function') {
                mentions.forEach(callback, this)
            } else {
                Array.prototype.forEach.call(mentions, callback, this); // old IE workaround
            }
        }
    }

    componentWillUnmount() {
        if(this.itemElement) {
            let mentions = this.itemElement.querySelectorAll('.mention');

            let callback = function (mention) {
                for (let event in this.mentionEvents) {
                    mention.removeEventListener(event, this.mentionEvents[event])
                }
            };

            if (typeof mentions.forEach == 'function') {
                mentions.forEach(callback, this);
            } else {
                Array.prototype.forEach.call(mentions, callback, this); // old IE workaround
            }
        }
    }

    static parseEmojies (msg) {
        if(typeof msg !== 'string') return msg;

        let re = /([\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]+)/ug;
        return msg.replace(re, '<u>$1</u>'); //Fix for directly injected emoji; Double-wraps emojies inserted via editor menu; Wraps emoji into a tag so we can style it separately of the message
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(prevState.message !== nextProps.message.rendered) {
            return {
                parsed_message: ChatLogItemGeneral.parseEmojies(nextProps.message.rendered)
            };
        }

        return null;
    }

    isUserMutable() {
        let {user, currentUser, currentRoomInfo} = this.props;
        if (currentRoomInfo.type === ROOM_TYPE_PERSONAL && currentRoomInfo.creator.uid === currentUser.uid) {
            return true;
        }
        //console.log(user);
        //console.log(currentUser);
        //console.log(currentRoom);
        let is_user_mutable = (!user.isXXL() && (currentUser.isOwner() || (currentUser.gift_rank > 0 && currentUser.isXXL())));

        return is_user_mutable;
    }

    render() {
        const lang = Registry.get('locale');

        let {message, user, currentUser, onAuthorMouseEnter, onAuthorMouseMove, onAuthorMouseLeave} = this.props;

        if (!user) {
            user = new BobTVUser({uid: message.uid, ufrag: message.ufrag, nick: message.nick, online: false});
        }

        if (currentUser.isBeingBlocked(user)) {
            return null;
        }

        if (!this.state.parsed_message) {
            return null;
        }

        let additionalClasses = ['message'],
            nick = user.nick,
            dateFormatted = '';

        let userClass = '';

        if (user.online) {
            if (user.gender === 1) {
                userClass += "male";
            } else if (user.gender === 2) {
                userClass += "female";
            } else if (user.gender === 3) {
                userClass += "couple";
            }
             else if (user.gender === 4) {
                userClass += "trans";
            }
            if (BobTVUser.isXXL(user)) {
                userClass += " pro";
            }
        }

        let giftRank = user.gift_rank ? 'rank-' + user.gift_rank : '';
        let generosityRank = user.generosity_rank ? `generosity chat rank-${user.generosity_rank}` : '';

        let is_user_mutable = this.isUserMutable();
        let is_user_unmuted = user.certified || (!user.online && !user.updated_offline);

        return (
            <div className={additionalClasses.join(' ')} ref={(ref) => this.itemElement = ref}>
                {is_user_mutable && is_user_unmuted && (
                    <div className="mute-button" onClick={this.onMute} title={lang.mute_one_hour} />
                )}
                {is_user_mutable && !is_user_unmuted && (
                    <div className="unmute-button" onClick={this.onUnMute} title={lang.unmute_one_hour} />
                )}
                <span className={`user-icon-message ${giftRank} ${user.generosity_rank ? 'not-only' : ''}`}>
                    <span className={`user-icon-message ${generosityRank} ${giftRank !== '' ? 'not-only' : ''}`}/>
                </span>
                <span
                    className={'author ' + userClass}
                    onClick={this.onAuthorLeftClick}
                    onContextMenu={(event) => this.onAuthorRightClick(event, user)}
                    onMouseEnter={onAuthorMouseEnter ? (event) => onAuthorMouseEnter(event, user, this) : null}
                    onMouseMove={onAuthorMouseMove ? (event) => onAuthorMouseMove(event, user, this) : null}
                    onMouseLeave={onAuthorMouseLeave ? (event) => onAuthorMouseLeave(event, user, this) : null}
                >
                    {nick}
                </span>
                <span className="colon">{lang.colon}</span>
                <span className="text" title={dateFormatted} dangerouslySetInnerHTML={{__html:this.state.parsed_message}}/>

            </div>
        );
    }
}

// todo: maybe connect() with 'users' substate as prop

const mapDispatchToProps = {
    updateUserOffline
}

export default connect(null, mapDispatchToProps)(ChatLogItemGeneral);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemGeneral/index.js